import DashboardLine from '@/screens/home/components/DashboardLine.jsx';

const DashboardLines = () => {
  return (
    <>
      <DashboardLine location={'left'} />
      <DashboardLine location={'right'} />
      <DashboardLine location={'top'} />
      <DashboardLine location={'bottom'} />
    </>
  );
};

export default DashboardLines;
